import _ from 'lodash';

export function commonDefaultState (single: string, plural: string) {
    const singleProp = single.charAt(0).toUpperCase() + single.slice(1);
    const pluralProp = plural.charAt(0).toUpperCase() + plural.slice(1);
    return {
        [plural]: [],
        [`isFetching${pluralProp}`]: false,
        [`isCreating${singleProp}`]: false,
        error: null
    };
}

const defaultState:any = {}

// Projects, sitecards and bookmarks which have a list
// Need slight tweak to work with search, comparable, analysis which only one is loaded in at once
export function commonHigherOrderReducer (single: string, plural: string) {
    const singleUpper = single.toUpperCase();
    const singleProp = single.charAt(0).toUpperCase() + single.slice(1);
    const pluralUpper = plural.toUpperCase();
    const pluralProp = plural.charAt(0).toUpperCase() + plural.slice(1);
    return function reducer (state = defaultState, action:{[key:string]:any}) {
        switch (action.type) {
            case `FETCH_${pluralUpper}_REQUEST`:
                return {
                    ...state,
                    [`isFetching${pluralProp}`]: true,
                    error: null
                };
            case `FETCH_${pluralUpper}_SUCCESS`:
                return {
                    ...state,
                    [`isFetching${pluralProp}`]: false,
                    [plural]: action[plural],
                    error: null
                };
            case `FETCH_${pluralUpper}_FAILURE`:
                return {
                    ...state,
                    [`isFetching${pluralProp}`]: false,
                    error: action.error
                };

            case `CREATE_${singleUpper}_REQUEST`:
                return {
                    ...state,
                    [`isCreating${singleProp}`]: true,
                    error: null
                };
            case `CREATE_${singleUpper}_SUCCESS`:
                return {
                    ...state,
                    [`isCreating${singleProp}`]: false,
                    [plural]: [...state[plural], action[single]],
                    error: null
                };
            case `CREATE_${singleUpper}_FAILURE`:
                return {
                    ...state,
                    [`isCreating${singleProp}`]: false,
                    error: action.error
                };

            case `FETCH_${singleUpper}_REQUEST`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults[idx] = {
                    ...(idx === -1 ? {} : newResults[idx]),
                    id: action.id,
                    [`isFetching${singleProp}`]: true,
                    error: null
                };
                return {
                    ...state,
                    [plural]: newResults
                };
            }
            case `FETCH_${singleUpper}_SUCCESS`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults[idx] = {
                    ...newResults[idx],
                    ...action[single],
                    [`isFetching${singleProp}`]: false,
                    error: null
                };
                return {
                    ...state,
                    [plural]: newResults
                };
            }
            case `FETCH_${singleUpper}_FAILURE`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults[idx] = {
                    ...newResults[idx],
                    [`isFetching${singleProp}`]: false,
                    error: action.error
                };
                return {
                    ...state,
                    [plural]: newResults
                };
            }

            case `RENAME_${singleUpper}_REQUEST`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults[idx] = {
                    ...(idx === -1 ? {} : newResults[idx]),
                    id: action.id,
                    [`isRenaming${singleProp}`]: true,
                    error: null
                };
                return {
                    ...state,
                    [plural]: newResults
                };
            }
            case `RENAME_${singleUpper}_SUCCESS`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults[idx] = {
                    ...newResults[idx],
                    name: action.name,
                    [`isRenaming${singleProp}`]: false,
                    error: null
                };
                return {
                    ...state,
                    [plural]: newResults
                };
            }
            case `RENAME_${singleUpper}_FAILURE`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults[idx] = {
                    ...newResults[idx],
                    [`isRenaming${singleProp}`]: false,
                    error: action.error
                };
                return {
                    ...state,
                    [plural]: newResults
                };
            }

            case `DELETE_${singleUpper}_REQUEST`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults[idx] = {
                    ...(idx === -1 ? {} : newResults[idx]),
                    id: action.id,
                    [`isDeleting${singleProp}`]: true,
                    error: null
                };
                return {
                    ...state,
                    [plural]: newResults
                };
            }
            case `DELETE_${singleUpper}_SUCCESS`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults.splice(idx, 1);
                return {
                    ...state,
                    [plural]: newResults
                };
            }
            case `DELETE_${singleUpper}_FAILURE`: {
                const newResults = [...state[plural]];
                const idx = newResults.findIndex(el => el.id === action.id);
                newResults[idx] = {
                    ...newResults[idx],
                    [`isDeleting${singleProp}`]: false,
                    error: action.error
                };
                return {
                    ...state,
                    [plural]: newResults
                };
            }

            default:
                return state;
        }
    };
}